import { render, staticRenderFns } from "./PayFunctionArea.vue?vue&type=template&id=63c64468&scoped=true&"
import script from "./PayFunctionArea.vue?vue&type=script&lang=js&"
export * from "./PayFunctionArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c64468",
  null
  
)

export default component.exports